export default __webpack_public_path__ + "static/media/inversionporarea.a6d5c4b2.png";